import moment from 'moment'
import {
  array,
  bool,
  object,
  string,
}             from 'yup'

import { ProgramDetails }        from '../../../api'
import { genArgConverter, unix } from '../../../utils'
import { i18nErrorCodes }        from '../form-utils'
import { integerMin1 }           from './formatSchemas'

const {
  required,
} = i18nErrorCodes

const sessions = integerMin1.required(required)

const createProgramFields = {
  sessions,

  /* TODO: is check a problem? (checks if id > 1, should check if id exists/is-selected) */
  companyId: integerMin1.required(required),

  name:  string().required(required),
  start: string().required(required),
  end: string().required(required),
  processes: array(),
  automaticMatch: bool(),
}

export const mentoringProgramSchema = object().shape(createProgramFields)

export default mentoringProgramSchema

export const coachingProgramSchema = object().shape({
  ...createProgramFields,
  companyPrice:           integerMin1.required(required),
  coachPrice:             integerMin1.required(required),
  coachPrices:            array(),
  finalEvaluation:        bool().required(required),
  tripartitaInitial:      bool().required(required),
  tripartitaIntermediate: bool().required(required),
  tripartitaFinal:        bool().required(required),
})

export const editProgramSchema = object().shape({
  sessions,
  name:      string().required(required),
  processes: array(),
  automaticMatch: bool(),

})

interface ProcessPair {
  teacher: string,
  student: string
}

/*
 * no idea why this can't be a flat object in the api spec but it creates some really
 * unnecessary complexity that is easier removed by converting the form-data-structure to
 * the specified request body on submission than handling the form-data-collecting with
 * this data-model
 * */
export interface ProgramFormValues extends ProgramDetails {
  companyId: number
  processes: ProcessPair []
  finalEvaluation: boolean
}

const commons = {
  companyId:       undefined,
  name:            '',
  start:           moment().valueOf(),
  end:             moment().valueOf(),
  sessions:        0,
  processes:       [],
  finalEvaluation: false,
  automaticMatch: false,
  automaticMatchEmailList: '',
}

export const emptyMentoringProgram = {
  ...commons,
}

export const emptyCoachingProgram = {
  ...commons,
  companyPrice:           0,
  coachPrice:             0,
  coachPrices:            [],
  tripartitaInitial:      true,
  tripartitaIntermediate: true,
  tripartitaFinal:        true,
}

/* TODO: this is so weird, please refactor */
const convertProcesses = processes => {
  const teachers = processes.map(process => process.teacher.email || process.teacher)
  const students = processes.map(process => process.student.email || process.student)

  const uniqueCombinations: any [] = []

  return processes
    .filter(
      (process, i) => {
        const uniqueCombination = teachers[ i ] + students[ i ]

        if (uniqueCombinations.indexOf(uniqueCombination) !== -1) {
          return false
        }

        uniqueCombinations[ i ] = uniqueCombination

        return true
      }
    )
    .map(
      process => ({
        ...process,
        teacher: process.teacher.email || process.teacher,
        student: process.student.email || process.student,
      })
    )
}

const convertBaseProgram = ({
  name,
  start,
  end,
  sessions,
  processes,
  ...rest
}) => ({
  details:   {
    name,
    sessions,
    start: typeof start === 'number' ? start : unix(start),
    end: typeof end === 'number' ? end : unix(end),
  },
  processes: convertProcesses(processes),
  ...rest,
})

export const convertMentoringProgram = convertBaseProgram

export const convertCoachingProgram =
  ({
    sessions,
    name,
    start,
    end,
    companyPrice,
    coachPrice,
    tripartitaInitial,
    tripartitaIntermediate,
    tripartitaFinal,
    processes,
    ...rest
  }) => ({
    tripartita: {
      initial:      tripartitaInitial,
      intermediate: tripartitaIntermediate,
      final:        tripartitaFinal,
    },
    prices:     {
      companyPrice,
      coachPrice,
    },
    ...convertBaseProgram({
      name,
      start,
      end,
      sessions,
      companyPrice,
      processes,
    }),
    ...rest
  })

export const convertEditProgram = genArgConverter(
  (
    id,
    {
      name,
      sessions,
      processes,
      automaticMatch,
      automaticMatchEmailList
    },
  ) => [
    id,
    {
      name,
      sessions,
      processes: convertProcesses(processes),
      automaticMatch,
      automaticMatchEmailList
    },
  ]
)

export const convertDeleteProgram = genArgConverter(
  (
    id,
    {
      name,
      sessions,
      processes,
      automaticMatch,
      automaticMatchEmailList
    },
  ) => [
    id,
    {
      name,
      sessions,
      processes,
      automaticMatch,
      automaticMatchEmailList
    },
  ]
)



// WEBPACK FOOTER //
// ./src/components/forms/schemas/program.schema.ts